// extracted by mini-css-extract-plugin
module.exports = {"doNotMoveButton":"MoveArtistModal-doNotMoveButton-193zi Button-button-2PYOE Link-link-1rgM9"};